export type NowActionKind = 'photo' | 'challenge' | 'poll' | 'appointment' | 'reveal' | 'complete' | null

export type NowActionState = Readonly<{
  beforeTrip: boolean
  photoDue: boolean
  photoDone: boolean
  challengeDue: boolean
  challengeDone: boolean
  pollDue: boolean
  appointmentNear: boolean
  revealAvailable: boolean
}>

export function selectNowAction(state: NowActionState): NowActionKind {
  if (state.beforeTrip) return 'appointment'
  if (state.photoDue) return 'photo'
  if (state.challengeDue) return 'challenge'
  if (state.pollDue) return 'poll'
  if (state.appointmentNear) return 'appointment'
  if (state.revealAvailable) return 'reveal'
  if (state.photoDone || state.challengeDone) return 'complete'
  return null
}
